
<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title">Email Templates</div>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-2">
      <div class="px-4 py-3">
        <!-- Invoice Template Override Section -->
        <div class="mt-2">
          <div class="text-right mb-2" v-if="editingInvoice">
            <button type="button" class="btn btn-sm btn-primary" @click="saveInvoiceTemplate">
              <span>Save Template</span>
            </button>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary mr-2"
            @click="toggleEditInvoice"
          >
            <span>{{ editingInvoice ? 'Cancel' : 'Edit' }}</span>
          </button>
          Invoice Template Override
          
          <div v-if="editingInvoice" class="mt-3 mb-4">
            <div class="form-group">
              <label class="font-weight-bold">Email Template</label>
              <small class="text-muted d-block mb-2">Compose your email naturally. Use [client] as a placeholder for the recipient's name. Separate paragraphs with a blank line.</small>
              <textarea v-model="invoiceTemplate" class="form-control" rows="12"></textarea>
            </div>
            
            <div class="alert alert-info">
              <strong>Preview:</strong>
              <div class="mt-2 p-3 bg-white border rounded" style="font-family: 'Times New Roman', serif; line-height: 1.6;" v-html="generatePreview()"></div>
            </div>
          </div>
        </div>
        <hr />
        
        <div class="mt-2">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary mr-2"
            v-on:click="viewConsentEmail()"
          >
            <span>View</span>
          </button>
          Email consent
        </div>
        <hr />
        <div class="mt-2">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary mr-2"
            v-on:click="viewDiscloseFeeSchedule()"
          >
            <span>View</span>
          </button>
          Disclose fee schedule in effect
        </div>
        <hr />
        <div class="mt-2">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary mr-2"
            v-on:click="viewUpdatedFeeSchedule()"
          >
            <span>View</span>
          </button>
          Updated fee schedule
        </div>
      </div>
    </div>
  </div>
</div>
